import React from 'react'

const ProjectsLayout = ({ children }) => {
  return <div>{children}</div>
}

export default ProjectsLayout
